import { atomFamily } from 'recoil';

export const uploadFileAtomFamily = atomFamily<File | null, string>({
  key: 'uploadFileAtomFamily',
  default: null,
});
